import { ActionTypes } from "./constants";

const initialState = {
  isVisible: false,
  title: "",
  width: "95%",
  content: "",
  
  isVisible2: false,
  title2: "",
  width2: "90%",
  content2: "",
};

const PopupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.TOGGLE_VISIBLE:
      return { ...state, 
        isVisible: payload.visible, 
        title: payload.title ? payload.title : '',
        width: payload.width ? payload.width : "95%",
        content: payload.content ? payload.content : '',
      }
      case ActionTypes.TOGGLE_VISIBLE2:
        return { ...state, 
          isVisible2: payload.isVisible2, 
          title2: payload.title2 ? payload.title2 : '',
          width2: payload.width2 ? payload.width2 : "90%",
          content2: payload.content2 ? payload.content2 : '',
        }
    default:
      return state;
  }
};

export default PopupReducer;
